import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import IframeModal from '@/ui-kit/components/modal/iframe';
import { ListingGalleryActionTitle } from '../enums';
import BaseOpenModalAction from '@/components/listing-card/helpers/base-open-modal.action';

export default class Take3DTourAction extends BaseOpenModalAction {
  title = ListingGalleryActionTitle.Take3DTour;
  icon = IconType.Rotate;
  colorSchema = StyleColorSchemeType.Gray;

  // eslint-disable-next-line class-methods-use-this
  openModal({ virtualTour }) {
    return ModalService.open({
      component: IframeModal,
      data: { sourceLink: virtualTour },
    });
  }
}
